__turbopack_context__.v({
  "card": "tI8H-W_card",
  "cardSubtitle": "tI8H-W_cardSubtitle",
  "cardTitle": "tI8H-W_cardTitle",
  "grid": "tI8H-W_grid",
  "text": "tI8H-W_text",
});
